// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607310704/js/" + chunkId + "." + {"44":"3519fde2","225":"e0da5a44","481":"7798f0d8","486":"528922e0","770":"ec8c390a"}[chunkId] + ".0.8250245356444184.chunk.js";
};